import { useDispatch, useSelector } from 'react-redux';
import { setAvatar } from '../../actions/user-actions-types';
import avatars from '../../constants/avatars';
import { isSmartPhone } from '../../utilities/helper';
import useTheme from '../../utilities/hooks/theme';
import SelectAvatarMWeb from './index_mWeb';
import SelectAvatarWeb from './index_web';

const SelectAvatar = () => {
  const { AccountTheme: theme } = useTheme();
  const { avatarId } = useSelector((state: any) => state.user);
  const dispatch = useDispatch();
  const onSelectAvatar = (newAvatarId: any) => {
    dispatch(setAvatar(newAvatarId));
  };
  const selectedBtnStyle = {
    background: theme.selectAvatarSelectedButtonBg,
    boxShadow: theme.selectAvatarSelectedButtonBoxShadow,
    border: `1px solid ${theme.selectAvatarSelectedButtonBorder}`
  };
  const freeBtnStyle = {
    background: theme.selectAvatarFreeButtonBg,
    boxShadow: theme.selectAvatarFreeButtonBoxShadow,
    border: `1px solid ${theme.selectAvatarFreeButtonBorder}`
  };
  const props = {
    avatarList: avatars,
    onSelectAvatar: onSelectAvatar,
    avatarId: avatarId,
    selectedBtnStyle: selectedBtnStyle,
    freeBtnStyle: freeBtnStyle
  };
  if (isSmartPhone) {
    return <SelectAvatarMWeb {...props} />;
  } else {
    return <SelectAvatarWeb {...props} />;
  }
};

export default SelectAvatar;
